module.exports = __webpack_public_path__ + "assets/media/status.c73ba854.svg";